
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Image, Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import useFetchBookCategories from "../../hooks/useFetchBookCategories";
import { ApiUrl } from "../../../ApiUrl";

// import "./AdmADHOCFee.css";

import useFetchBookSubCategories from "../../hooks/useFetchBookSubCategories";

const BookForm = () => {
  const location = useLocation();
  const bookData = location.state?.data; // Retrieve passed data

  // Log the received data for verification
  console.log("Received Data in BookForm:", bookData);

  const [bookStatus, setBookStatus] = useState({
    value: "ACTIVE",
    label: "ACTIVE",
  });

  const [bookCategory, setBookCategory] = useState("");
  const [bookSubCategory, setBookSubCategory] = useState("");
  const [locations, setLocations] = useState([]);
  const [frontCover, setFrontCover] = useState(null);
  const [backCover, setBackCover] = useState(null);
  const [branches, setBranches] = useState([]);
  const [branch, setBranch] = useState("");
  const initialRows = [
    {
      id: 1,
      dateOfPurchase: "",
      purchasedFrom: "",
      billNo: "",
      noOfCopies: "",
      cost: "",
      
    },
  ];
  const [rows, setRows] = useState(initialRows);
  const [accessionRows, setAccessionRows] = useState([]);
  const navigate = useNavigate();
  const updatedData = location.state;
  const { categories } = useFetchBookCategories();
  const { subCategories } = useFetchBookSubCategories(bookCategory);
  const [categoryId, setCategoryId] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [nextBarcode, setNextBarcode] = useState(null);
  const [typeofBooks, setTypeofBooks] = useState("");
  const [bookJournal, setBookJournal] = useState(null);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});

  const [bookDetails, setBookDetails] = useState({
    book_code: "",
    book_name: "",
    publisher: "",
    author: "",
    publish_year: "",
    volume: "",
    ISBN: "",
    edition: "",
    pages: "",
    type: "",
    total_no_of_copies: 0,
    book_status: "ACTIVE",
    front_cover: "", // Front cover URL or file
    back_cover: "", // Back cover URL or file
  });

  // const handleBookStatusChange = (event) => {
  //   setBookStatus(event.target.value); // Update state based on selection
  // };

  const bookStatusOptions = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];
const handleClear = () => {
  // Revoke object URLs before clearing
  if (frontCover?.preview) {
    URL.revokeObjectURL(frontCover.preview);
  }
  if (backCover?.preview) {
    URL.revokeObjectURL(backCover.preview);
  }

  setBookDetails({
    book_code: "",
    book_name: "",
    publisher: "",
    author: "",
    publish_year: "",
    volume: "",
    ISBN: "",
    edition: "",
    pages: "",
    type: "",
    total_no_of_copies: 0,
    book_status: "ACTIVE",
    front_cover: "",
    back_cover: "",
  });

  setBookStatus({ value: "ACTIVE", label: "ACTIVE" });
  setBookCategory("");
  setBookSubCategory("");
  setBookJournal(null);
  setBranch("");
  setFrontCover(null);
  setBackCover(null);
  setErrors({});
  setError("");

  setRows([
    {
      id: 1,
      dateOfPurchase: "",
      purchasedFrom: "",
      billNo: "",
      noOfCopies: "",
      cost: "",
     
    },
  ]);

  setAccessionRows([]);
  setIsChecked(false);
  setNextBarcode(null);
  setTypeofBooks("");
};


  const handleBookStatusChange = (selectedOption) => {
    setBookStatus(selectedOption);
  };
  useEffect(() => {
    if (bookDetails?.total_no_of_copies > 0) {
      setErrors((prev) => ({ ...prev, total_no_of_copies: "" })); // Clear error
    }
  }, [bookDetails?.total_no_of_copies]);



useEffect(() => {
  if (bookData?.bookDetails?.length > 0) {
    const firstBookDetails = bookData.bookDetails[0];
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      ...firstBookDetails,
      type: firstBookDetails.type?.toLowerCase(),
      total_no_of_copies: firstBookDetails.no_of_copies || 0,
    }));

    // Build proper image preview
    if (firstBookDetails.front_cover) {
      const frontCoverSrc = firstBookDetails.front_cover.binary_data
        ? `data:${firstBookDetails.front_cover.type};base64,${firstBookDetails.front_cover.binary_data}`
        : `${ApiUrl.apiurl}${firstBookDetails.front_cover.path}`;
      setFrontCover({ preview: frontCoverSrc });
    }

    if (firstBookDetails.back_cover) {
      const backCoverSrc = firstBookDetails.back_cover.binary_data
        ? `data:${firstBookDetails.back_cover.type};base64,${firstBookDetails.back_cover.binary_data}`
        : `${ApiUrl.apiurl}${firstBookDetails.back_cover.path}`;
      setBackCover({ preview: backCoverSrc });
    }

    // Purchases
    if (bookData?.purchesDetails?.length > 0) {
      const purchaseRows = bookData.purchesDetails.map((purchase) => ({
        id: purchase.id,
        dateOfPurchase: purchase.purchase_date,
        purchasedFrom: purchase.purchase_from,
        billNo: purchase.bill_no,
        noOfCopies: purchase.no_of_copies,
        cost: purchase.bill_value,
      
      }));
      setRows(purchaseRows);
    }

    // Barcode locations
    if (bookData?.BarcodeLocationDetails?.length > 0) {
      const locationRows = bookData.BarcodeLocationDetails.map((barcode) => ({
        id: barcode.id,
        barcode: barcode.barcode,
        location: barcode.locationId,
        status: barcode.book_barcode_status,
        remarks: barcode.remarks,
      }));
      setAccessionRows(locationRows);
    }

    setBookCategory(firstBookDetails.book_categoryId);
    setBookSubCategory(firstBookDetails.book_subcategoryId);
    setBranch(firstBookDetails.library_branch_id);

    console.log("Updated Book Details:", firstBookDetails);
  } else {
    setFrontCover(null);
    setBackCover(null);
  }
}, [bookData]);




//  const handleFileUpload = (event, setFile, key) => {
//    const file = event.target.files[0];
//    if (file) {
//      const reader = new FileReader();
//      reader.onloadend = () => {
//        const fileObj = {
//          file,
//          name: file.name,
//          preview: reader.result,
//        };

//        // Optional: store for later use, but not preload on page load
//        sessionStorage.setItem(key, JSON.stringify(fileObj));

//        setFile(fileObj);
//      };
//      reader.readAsDataURL(file);
//    }
//  };
const handleFileUpload = (event, setFile) => {
  const file = event.target.files[0];
  if (file) {
    const preview = URL.createObjectURL(file);

    const fileObj = {
      file,
      name: file.name,
      preview, // Blob URL (lightweight, not Base64)
    };

    setFile(fileObj);
  }
};



  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name, // Label for display
  }));
  const subCategoryOptions = subCategories.map((subCategory) => ({
    value: subCategory.id,
    label: subCategory.name, // Label for display
  }));

  const handleCategoryChange = (selectedOption) => {
    setBookCategory(selectedOption ? selectedOption.value : null);
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      book_categoryId: selectedOption ? selectedOption.value : null,
    }));
    setBookSubCategory(null); // Reset sub-category when category changes
  };

  const handleSubCategoryChange = (selectedOption) => {
    setBookSubCategory(selectedOption ? selectedOption.value : null);
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      book_subcategoryId: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleCheckboxChange = async () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);

    if (newCheckedState) {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}LIBRARYBOOK/NextbarcodeNo/`
        );
        const data = await response.json();
        if (data.message === "success") {
          setNextBarcode(data.next_barcode);

          // Update accessionRows with dynamic barcodes starting from `next_barcode`
          updateAccessionRows(rows, data.next_barcode);
        }
      } catch (error) {
        console.error("Error fetching barcode:", error);
      }
    } else {
      setNextBarcode(null);
      const resetRows = accessionRows.map((row) => ({ ...row, barcode: "" }));
      setAccessionRows(resetRows);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookDetails({
      ...bookDetails,
      [name]: value,
    });
  };
  const handleOptionChange = (selectedOption, name) => {
    setBookDetails({
      ...bookDetails,
      [name]: selectedOption.value,
    });
  };

  const bookJournalOptions = [
    { value: "book", label: "Book" },
    { value: "journal", label: "Journal" },
  ];

  const handleAddRow = () => {
    // Add a new row for the first table
    const newRow = {
      id: rows.length + 1,
      dateOfPurchase: "",
      purchasedFrom: "",
      billNo: "",
      noOfCopies: "",
      cost: "",
    
    };

    // Add a new row for the second table
    const newRowForAccessionRows = {
      id: accessionRows.length + 1, // Assign a new unique ID
      barcode: "",
      location: null,
      status: "",
      remarks: "",
    };

    // Update both states while preserving existing data
    setRows([...rows, newRow]);
    setAccessionRows([...accessionRows, newRowForAccessionRows]);
  };

  const handleRemoveRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleNoOfCopiesChange = (id, field, value) => {
    // Update the rows data
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);

    // Calculate the total number of copies based on all row values
    const totalCopies = updatedRows.reduce(
      (sum, row) => sum + (parseInt(row.noOfCopies) || 0),
      0
    );

    // Update bookDetails with the new total copies count
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      total_no_of_copies: totalCopies, // Update total copies dynamically
    }));

    // Call the updateAccessionRows function to update the accession rows based on the new number of copies
    updateAccessionRows(updatedRows, isChecked ? nextBarcode : null);
  };

  const updateAccessionRows = (rows, startingBarcode) => {
    // Calculate the total number of copies
    const totalCopies = rows.reduce(
      (sum, row) => sum + (parseInt(row.noOfCopies) || 0),
      0
    );

    // Ensure the number of accession rows matches the total number of copies
    const newAccessionRows = [];
    let existingRowIndex = 0;

    for (let i = 0; i < totalCopies; i++) {
      if (existingRowIndex < accessionRows.length) {
        // Preserve existing rows and update necessary fields
        const existingRow = accessionRows[existingRowIndex];
        newAccessionRows.push({
          ...existingRow,
          barcode: startingBarcode
            ? (parseInt(startingBarcode) + i).toString()
            : existingRow.barcode,
          location: existingRow.location || "",
          status: existingRow.status || "",
          remarks: existingRow.remarks || "",
        });
        existingRowIndex++;
      } else {
        // Create new rows if there aren't enough existing rows
        newAccessionRows.push({
          id: i + 1,
          barcode: startingBarcode
            ? (parseInt(startingBarcode) + i).toString()
            : "",
          location: "",
          status: "",
          remarks: "",
        });
      }
    }

    setAccessionRows(newAccessionRows);
  };

  useEffect(() => {
    const fetchBranches = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      if (!orgId || !branchId) {
        setError("Organization or branch ID not found in local storage.");
        return;
      }

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}LIBRARYBRANCH/GetLibraryBranchList/${orgId}/${branchId}/`
        );

        if (response.ok) {
          const result = await response.json();
          if (result.message === "success" && result.data) {
            const options = result.data.map((branch) => ({
              value: branch.library_branch_id, // Map branch ID to value
              label: branch.library_branch_name, // Map branch name to label
            }));
            setBranches(options); // Update branch options
          } else {
            setError("Failed to fetch branches.");
          }
        } else {
          setError(`Error fetching branches: ${response.statusText}`);
        }
      } catch (err) {
        setError(`Error: ${err.message}`);
      }
    };

    fetchBranches();
  }, []);

  const handleBranchChange = (selectedOption) => {
    setBranch(selectedOption ? selectedOption.value : ""); // Update selected branch ID
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      library_branch_id: selectedOption ? selectedOption.value : null, // Update the library_branch_id
    }));
    console.log("Selected Branch:", selectedOption);
  };

  useEffect(() => {
    const fetchLocations = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      if (!orgId || !branchId) return;

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}BOOK_LOCATION/GetALLBookLocationList/${orgId}/${branchId}/`
        );

        if (response.ok) {
          const result = await response.json();
          if (result.message === "success" && result.data) {
            const options = result.data.map((location) => ({
              value: location.id,
              label: location.booklocation,
            }));
            setLocations(options);
          }
        }
      } catch (err) {
        console.error("Error fetching locations:", err.message);
      }
    };

    fetchLocations();
  }, []);

  const validateFields = () => {
    let isValid = true;
    const newErrors = {};

    if (!bookDetails.book_code) {
      newErrors.book_code = "Book Code is required";
      isValid = false;
    }
    if (!bookDetails.book_name) {
      newErrors.book_name = "Book Name is required";
      isValid = false;
    }
    if (!bookStatus || !bookStatus.value) {
      newErrors.book_status = "Book Status is required";
      isValid = false;
    }
    if (!bookCategory) {
      newErrors.book_category_Id = "Book Category is required";
      isValid = false;
    }
    if (!bookSubCategory) {
      newErrors.book_sub_category_Id = "Book Sub-Category is required";
      isValid = false;
    }
    if (!bookDetails.total_no_of_copies) {
      newErrors.total_no_of_copies = "Total No. of Copies is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

 

  // const handleSave = async () => {
  //   const orgId = parseInt(localStorage.getItem("orgId"));
  //   const branchId = parseInt(localStorage.getItem("branchId"));
  //   const academicYearId = parseInt(localStorage.getItem("academicSessionId"));
  //   const loginId = parseInt(sessionStorage.getItem("userId"));

  //   if (!bookDetails?.book_code || !bookDetails?.book_name) {
  //     alert("Book Code and Book Name are required.");
  //     return;
  //   }

  //   const isUpdate = !!bookDetails.id;

  //   // Check for empty status in barcode rows
  //   const hasBlankStatus = accessionRows.some(
  //     (row) => row.status.trim() === ""
  //   );
  //   if (hasBlankStatus) {
  //     alert("Please select a status for all barcode rows.");
  //     return;
  //   }

  //   // Validate barcodes if not auto-generated and creating new book
  //   if (!isChecked && !isUpdate) {
  //     const barcodeList = accessionRows.map((item) => item.barcode);

  //     try {
  //       const validationResponse = await fetch(
  //         `${
  //           ApiUrl.apiurl
  //         }LIBRARYBOOK/LibraryBarcodeValidation/?barcodeList=[${barcodeList
  //           .map((barcode) => `"${barcode}"`)
  //           .join(",")}]`
  //       );

  //       const validationData = await validationResponse.json();

  //       if (validationResponse.ok && validationData.exists) {
  //         alert("Some of the entered barcodes already exist. Please check.");
  //         return;
  //       } else if (!validationResponse.ok) {
  //         alert("Failed to validate barcodes.");
  //         console.error("Validation Error:", validationData);
  //         return;
  //       }
  //     } catch (error) {
  //       console.error("Barcode validation error:", error);
  //       alert("An error occurred while validating barcodes.");
  //       return;
  //     }
  //   }

  //   // Build the book detail object
  //   const libraryBookdetails = {
  //     ...(isUpdate && { bookId: bookDetails.id }), // use bookId for update
  //     loginId,
  //     academicyearId: academicYearId,
  //     book_code: bookDetails.book_code,
  //     book_name: bookDetails.book_name,
  //     library_branch_Id: bookDetails.library_branch_id,
  //     book_category_Id: bookCategory || 1,
  //     book_sub_category_Id: bookSubCategory || 1,
  //     book_status: "Active",
  //     total_no_of_copies: parseInt(bookDetails.total_no_of_copies) || 1,
  //     publisher: bookDetails.publisher,
  //     author: bookDetails.author || "",
  //     publish_year: bookDetails.publish_year || new Date().getFullYear(),
  //     edition: bookDetails.edition || 1,
  //     ISBN: bookDetails.ISBN,
  //     createdDate: new Date().toISOString().split("T")[0],
  //     IssueNo: bookDetails.IssueNo || "ISS123",
  //     Period: bookDetails.Period || "Annual",
  //     org_id: orgId,
  //     branch_id: branchId,
  //     allow_issue: "T",
  //     type: bookDetails.type || "",
  //   };

  //   // Build barcode details
  //   const libraryBookBarcodeDetails = accessionRows
  //     .filter((row) => Object.values(row).some((value) => value !== ""))
  //     .map((row) => ({
  //       ...(isUpdate && row.id && { id: row.id }), // include id only when updating
  //       barcode: row.barcode,
  //       book_barcode_status: row.status || "exists",
  //       org_id: orgId,
  //       branch_id: branchId,
  //       locationId: row.location,
  //       created_by: loginId,
  //       remarks: row.remarks || "",
  //       barcode_auto_generated: isChecked ? true : false,
  //     }));

  //   if (!libraryBookBarcodeDetails.length) {
  //     alert("At least one barcode detail is required.");
  //     return;
  //   }

  //   // Build purchase details
  //   const librarypurchesDetails = rows
  //     .filter((row) => Object.values(row).some((value) => value !== ""))
  //     .map((row) => ({
  //       ...(isUpdate && row.id && { id: row.id }), // include id only when updating
  //       loginId,
  //       academicyearId: academicYearId,
  //       book_code: bookDetails.book_code,
  //       book_name: bookDetails.book_name,
  //       library_branch_Id: bookDetails.library_branch_id,
  //       book_category_Id: bookCategory || 1,
  //       created_by: loginId,
  //       purchase_date:
  //         row.dateOfPurchase || new Date().toISOString().split("T")[0],
  //       purchase_from: row.purchasedFrom || "",
  //       bill_no: row.billNo || "",
  //       bill_value: row.cost?.toString() || "",
  //       no_of_copies: row.noOfCopies?.toString() || "",
  //     }));

  //   if (!librarypurchesDetails.length) {
  //     alert("At least one purchase detail is required.");
  //     return;
  //   }

  //   // Construct FormData and append values
  //   const formData = new FormData();
  //   formData.append("created_by", loginId.toString());

  //   // Append file objects
  //   if (frontCover?.file) {
  //     formData.append("front_cover", frontCover.file);
  //   }

  //   if (backCover?.file) {
  //     formData.append("back_cover", backCover.file);
  //   }

  //   // Append JSON stringified values
  //   formData.append("libraryBookdetails", JSON.stringify(libraryBookdetails));
  //   formData.append(
  //     "libraryBookBarcodeDetails",
  //     JSON.stringify(libraryBookBarcodeDetails)
  //   );
  //   formData.append(
  //     "librarypurchesDetails",
  //     JSON.stringify(librarypurchesDetails)
  //   );

  //   const apiUrl = isUpdate
  //     ? `${ApiUrl.apiurl}LIBRARYBOOK/BOOK_UPDATE/`
  //     : `${ApiUrl.apiurl}LIBRARYBOOK/BOOK_CREATE/`;

  //   const method = isUpdate ? "PUT" : "POST";

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method,
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert(
  //         isUpdate ? "Book updated successfully!" : "Book saved successfully!"
  //       );
  //         handleClear(); 
  //     } else {
  //       alert(
  //         isUpdate ? "Failed to update the book." : "Failed to save the book."
  //       );
  //       console.error("Error response from server:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting book:", error);
  //     alert("An error occurred while saving the book.");
  //   }
  // };


  const handleSave = async () => {
    const orgId = parseInt(localStorage.getItem("orgId"));
    const branchId = parseInt(localStorage.getItem("branchId"));
    const academicYearId = parseInt(localStorage.getItem("academicSessionId"));
    const loginId = parseInt(sessionStorage.getItem("userId"));

    // ==========================
    // Required Field Validation
    // ==========================

    if (!orgId || isNaN(orgId)) {
      alert("Organization field is missing.");
      return;
    }

    if (!branchId || isNaN(branchId)) {
      alert("Branch field is missing.");
      return;
    }

    if (!academicYearId || isNaN(academicYearId)) {
      alert("Academic Year is missing.");
      return;
    }

    if (!loginId || isNaN(loginId)) {
      alert("User session has expired. Please login again.");
      return;
    }

    if (!bookDetails?.library_branch_id) {
      alert("Please select a Library Branch.");
      return;
    }

    if (!bookDetails?.book_code || !bookDetails?.book_name) {
      alert("Book Code and Book Name are required.");
      return;
    }

    const isUpdate = !!bookDetails.id;

    // Every accession detail is required before a book can be saved.
    if (!accessionRows.length) {
      alert("Please fill all Accession Details before saving.");
      return;
    }

    const incompleteAccessionIndex = accessionRows.findIndex(
      (row) =>
        !String(row.barcode ?? "").trim() ||
        !String(row.location ?? "").trim() ||
        !String(row.status ?? "").trim() ||
        !String(row.remarks ?? "").trim(),
    );

    if (incompleteAccessionIndex !== -1) {
      alert(
        `Please fill all fields in Accession Details row ${
          incompleteAccessionIndex + 1
        }.`,
      );
      return;
    }

    // Validate barcodes if not auto-generated and creating new book
    if (!isChecked && !isUpdate) {
      const barcodeList = accessionRows.map((item) => item.barcode);

      try {
        const validationResponse = await fetch(
          `${
            ApiUrl.apiurl
          }LIBRARYBOOK/LibraryBarcodeValidation/?barcodeList=[${barcodeList
            .map((barcode) => `"${barcode}"`)
            .join(",")}]`,
        );

        const validationData = await validationResponse.json();

        if (validationResponse.ok && validationData.exists) {
          alert("Some of the entered barcodes already exist. Please check.");
          return;
        } else if (!validationResponse.ok) {
          alert("Failed to validate barcodes.");
          console.error("Validation Error:", validationData);
          return;
        }
      } catch (error) {
        console.error("Barcode validation error:", error);
        alert("An error occurred while validating barcodes.");
        return;
      }
    }

    // Build the book detail object
    const libraryBookdetails = {
      ...(isUpdate && { bookId: bookDetails.id }),
      loginId,
      academicyearId: academicYearId,
      book_code: bookDetails.book_code,
      book_name: bookDetails.book_name,
      library_branch_Id: bookDetails.library_branch_id,
      book_category_Id: bookCategory || 1,
      book_sub_category_Id: bookSubCategory || 1,
      book_status: "Active",
      total_no_of_copies: parseInt(bookDetails.total_no_of_copies) || 1,
      publisher: bookDetails.publisher,
      author: bookDetails.author || "",
      publish_year: bookDetails.publish_year || new Date().getFullYear(),
      volume:
        bookDetails.volume === "" || bookDetails.volume === null
          ? null
          : parseInt(bookDetails.volume),
      edition: bookDetails.edition || 1,
      pages:
        bookDetails.pages === "" || bookDetails.pages === null
          ? null
          : parseInt(bookDetails.pages),
      ISBN: bookDetails.ISBN,
      createdDate: new Date().toISOString().split("T")[0],
      IssueNo: bookDetails.IssueNo || "ISS123",
      Period: bookDetails.Period || "Annual",
      org_id: orgId,
      branch_id: branchId,
      allow_issue: "T",
      type: bookDetails.type || "",
    };

    // Build barcode details
    const libraryBookBarcodeDetails = accessionRows
      .filter((row) => Object.values(row).some((value) => value !== ""))
      .map((row) => ({
        ...(isUpdate && row.id && { id: row.id }),
        barcode: row.barcode,
        book_barcode_status: row.status || "exists",
        org_id: orgId,
        branch_id: branchId,
        locationId: row.location,
        created_by: loginId,
        remarks: row.remarks || "",
        barcode_auto_generated: isChecked ? true : false,
      }));

    if (!libraryBookBarcodeDetails.length) {
      alert("At least one barcode detail is required.");
      return;
    }

    // Build purchase details
    const librarypurchesDetails = rows
      .filter((row) => Object.values(row).some((value) => value !== ""))
      .map((row) => ({
        ...(isUpdate && row.id && { id: row.id }),
        loginId,
        academicyearId: academicYearId,
        book_code: bookDetails.book_code,
        book_name: bookDetails.book_name,
        library_branch_Id: bookDetails.library_branch_id,
        book_category_Id: bookCategory || 1,
        created_by: loginId,
        purchase_date:
          row.dateOfPurchase || new Date().toISOString().split("T")[0],
        purchase_from: row.purchasedFrom || "",
        bill_no: row.billNo || "",
        bill_value: row.cost?.toString() || "",
        no_of_copies: row.noOfCopies?.toString() || "",
      }));

    if (!librarypurchesDetails.length) {
      alert("At least one purchase detail is required.");
      return;
    }

    const formData = new FormData();
    formData.append("created_by", loginId.toString());

    if (frontCover?.file) {
      formData.append("front_cover", frontCover.file);
    }

    if (backCover?.file) {
      formData.append("back_cover", backCover.file);
    }

    formData.append("libraryBookdetails", JSON.stringify(libraryBookdetails));

    formData.append(
      "libraryBookBarcodeDetails",
      JSON.stringify(libraryBookBarcodeDetails),
    );

    formData.append(
      "librarypurchesDetails",
      JSON.stringify(librarypurchesDetails),
    );

    const apiUrl = isUpdate
      ? `${ApiUrl.apiurl}LIBRARYBOOK/BOOK_UPDATE/`
      : `${ApiUrl.apiurl}LIBRARYBOOK/BOOK_CREATE/`;

    const method = isUpdate ? "PUT" : "POST";

    try {
      const response = await fetch(apiUrl, {
        method,
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        alert(
          isUpdate ? "Book updated successfully!" : "Book saved successfully!",
        );

        handleClear();
      } else {
        const errorMessage =
          data?.message ||
          data?.error ||
          data?.detail ||
          (isUpdate
            ? "Failed to update the book."
            : "Failed to save the book.");

        alert(errorMessage);
        console.error("Error response from server:", data);
      }
    } catch (error) {
      console.error("Error submitting book:", error);
      alert("An error occurred while saving the book.");
    }
  };

  const handleClose = () => {
    navigate("/admin/book-search");
  };

  const handleAccessionRowChange = (id, field, value) => {
    setAccessionRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  return (
    <div className="container-fluid ">
      <div className="row ">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                BOOK MASTER
              </p>
              <div className="row mb-2 mt-3 mx-0">
                <div className="col-12 p-2 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/bulk-book-upload")}
                  >
                    Bulk Upload
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="row flex-grow-1">
                    <Row className="mb-3 mt-2">
                      <Col>
                        <Form.Group controlId="bookJournal">
                          <Form.Label>
                            Book/Journal<span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Select
                            id="book-journal"
                            className="detail"
                            options={bookJournalOptions}
                            value={
                              bookJournalOptions.find(
                                (option) => option.value === bookDetails.type
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              setBookDetails((prevDetails) => ({
                                ...prevDetails,
                                type: selectedOption
                                  ? selectedOption.value
                                  : null,
                              }));
                              setErrors((prev) => ({ ...prev, type: "" })); // Clear error
                            }}
                            placeholder="Select Book/Journal"
                            styles={{
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "13px", // reduce this value as needed
                              }),
                            }}
                          />
                          {errors.type && (
                            <div className="text-danger">{errors.type}</div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="category">
                          <Form.Label>
                            Category<span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Select
                            id="category"
                            className="detail"
                            options={categoryOptions}
                            onChange={(selectedOption) => {
                              handleCategoryChange(selectedOption);
                              setErrors((prev) => ({
                                ...prev,
                                bookCategory: "",
                              })); // Clear error
                            }}
                            value={
                              categoryOptions.find(
                                (option) => option.value === bookCategory
                              ) || null
                            }
                            placeholder="Select Category"
                            styles={{
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "13px", // reduce this value as needed
                              }),
                            }}
                          />
                          {errors.bookCategory && (
                            <div className="text-danger">
                              {errors.bookCategory}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="subCategory">
                          <Form.Label>
                            Sub Category<span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Select
                            id="sub-category"
                            className="detail"
                            options={subCategoryOptions}
                            onChange={(selectedOption) => {
                              handleSubCategoryChange(selectedOption);
                              setErrors((prev) => ({
                                ...prev,
                                bookSubCategory: "",
                              })); // Clear error
                            }}
                            value={
                              subCategoryOptions.find(
                                (option) => option.value === bookSubCategory
                              ) || null
                            }
                            placeholder="Select Sub Category"
                            styles={{
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "13px", // reduce this value as needed
                              }),
                            }}
                            isDisabled={!subCategoryOptions.length}
                          />
                          {errors.bookSubCategory && (
                            <div className="text-danger">
                              {errors.bookSubCategory}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="bookCode">
                          <Form.Label>
                            Book Code<span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter book code"
                            className="form-control detail"
                            name="book_code"
                            value={bookDetails.book_code}
                            onChange={(e) => {
                              handleChange(e);
                              setErrors((prev) => ({ ...prev, book_code: "" })); // Clear error
                            }}
                          />
                          {errors.book_code && (
                            <div className="text-danger">
                              {errors.book_code}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="bookTitle">
                          <Form.Label>
                            Book Title<span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter book title"
                            name="book_name"
                            value={bookDetails.book_name}
                            onChange={(e) => {
                              handleChange(e);
                              setErrors((prev) => ({ ...prev, book_name: "" })); // Clear error
                            }}
                          />
                          {errors.book_name && (
                            <div className="text-danger">
                              {errors.book_name}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Form.Group controlId="publisher">
                          <Form.Label>Publisher</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter publisher"
                            value={bookDetails.publisher}
                            name="publisher"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="author">
                          <Form.Label>Author</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter author"
                            value={bookDetails.author}
                            name="author"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="publish year">
                          <Form.Label>Publish Year</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter publish year"
                            value={bookDetails.publish_year}
                            onChange={handleChange}
                            name="publish_year"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="volume">
                          <Form.Label>Volume</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter volume"
                            value={bookDetails.volume}
                            onChange={handleChange}
                            name="volume"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="volume">
                          <Form.Label>ISBN</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter ISBN"
                            value={bookDetails.ISBN}
                            onChange={handleChange}
                            name="ISBN"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Form.Group controlId="edition">
                          <Form.Label>Edition</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter edition"
                            value={bookDetails.edition}
                            name="edition"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="pages">
                          <Form.Label>Pages</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control detail"
                            placeholder="Enter pages"
                            value={bookDetails.pages}
                            name="pages"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="totalCopies">
                          <Form.Label>
                            Total No. of Copies
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            className="form-control detail"
                            placeholder="0"
                            name="total_no_of_copies"
                            value={bookDetails.total_no_of_copies}
                            disabled
                          />
                          {errors.total_no_of_copies && (
                            <div className="text-danger">
                              {errors.total_no_of_copies}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="totalCopies">
                          <Form.Label>Branch</Form.Label>
                          <span style={{ color: "red" }}>*</span>
                          <Select
                            id="branch"
                            className="detail"
                            options={branches} // Dropdown options (id mapped to value, name to label)
                            value={
                              branch
                                ? branches.find(
                                    (option) => option.value === branch
                                  )
                                : null
                            } // Match selected branch ID to options
                            onChange={handleBranchChange} // Handle branch selection
                            placeholder="Select Branch"
                            styles={{
                              placeholder: (base) => ({
                                ...base,
                                fontSize: "13px", // reduce this value as needed
                              }),
                            }}
                            classNamePrefix="react-select-branch" // Allow clearing the selection
                          />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="bookStatus">
                          <Form.Label>
                            Book Status <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Select
                            classNamePrefix="detail"
                            value={bookStatus}
                            onChange={(selectedOption) => {
                              handleBookStatusChange(selectedOption);
                              setErrors((prev) => ({
                                ...prev,
                                bookStatus: "",
                              }));
                            }}
                            options={bookStatusOptions}
                            placeholder="Select Status"
                          />
                          {errors.bookStatus && (
                            <div className="text-danger">
                              {errors.bookStatus}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <div className="row custom-section-box  mt-3 mb-3 mx-2">
                <Row className="mb-3 mt-3">
                  <Col>
                    <Form.Group controlId="uploadFrontCover">
                      <Form.Label className="mb-2">
                        Upload Book Front Cover
                      </Form.Label>
                      <Form.Control
                        type="file"
                        className="form-control detail"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileUpload(e, setFrontCover, "frontCover")
                        }
                      />
                    </Form.Group>
                    {frontCover && (
                      <Image
                        src={frontCover.preview}
                        alt="Front Cover Preview"
                        thumbnail
                        style={{
                          marginTop: "10px",
                          width: "120px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Col>

                  <Col>
                    <Form.Group controlId="uploadBackCover">
                      <Form.Label className="mb-2">
                        Upload Book Back Cover
                      </Form.Label>
                      <Form.Control
                        type="file"
                        className="form-control detail"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileUpload(e, setBackCover, "backCover")
                        }
                      />
                    </Form.Group>
                    {backCover && (
                      <Image
                        src={backCover.preview}
                        alt="Back Cover Preview"
                        thumbnail
                        style={{
                          marginTop: "10px",
                          width: "120px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </div>

              <Form.Group controlId="autoGenerate">
                <div
                  className="mx-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Check
                    label="Do you want Book Accession No. to be auto-generated?"
                    type="checkbox"
                    inline
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  {nextBarcode !== null && (
                    <span style={{ marginLeft: "10px" }}>
                      Next Accession Number will start from {nextBarcode}
                    </span>
                  )}
                </div>
              </Form.Group>

              <div className="col-12">
                <h5 className="mt-4">Book Source Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Date of Purchase</th>
                        <th className="d-none d-md-table-cell">
                          Purchased From
                        </th>
                        <th className="d-none d-md-table-cell">Bill No</th>
                        <th>No. of Copies</th>
                        <th>Cost/Bill Value</th>
                        <th>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>
                            <Form.Control
                              type="date"
                              className="form-control detail"
                              value={row.dateOfPurchase}
                              size="sm"
                              onChange={(e) =>
                                handleNoOfCopiesChange(
                                  row.id,
                                  "dateOfPurchase",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="d-none d-md-table-cell">
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              value={row.purchasedFrom}
                              size="sm"
                              onChange={(e) =>
                                handleNoOfCopiesChange(
                                  row.id,
                                  "purchasedFrom",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="d-none d-md-table-cell">
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              value={row.billNo}
                              size="sm"
                              onChange={(e) =>
                                handleNoOfCopiesChange(
                                  row.id,
                                  "billNo",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              value={row.noOfCopies}
                              size="sm"
                              onChange={(e) =>
                                handleNoOfCopiesChange(
                                  row.id,
                                  "noOfCopies",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              value={row.cost}
                              size="sm"
                              onChange={(e) =>
                                handleNoOfCopiesChange(
                                  row.id,
                                  "cost",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleRemoveRow(row.id)}
                              disabled={rows.length === 1}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="8" className="text-end">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleAddRow}
                          >
                            Add Row
                          </Button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <div className="col-12">
                <h5 className="mt-4">Accession Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Accession No.</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accessionRows.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              Accession
                              Details
                              value={row.barcode}
                              style={{ width: "100%", padding: "5px" }}
                              size="sm"
                              onChange={(e) => {
                                // Allow manual input when checkbox is unchecked
                                if (!isChecked) {
                                  const updatedRows = accessionRows.map((r) =>
                                    r.id === row.id
                                      ? { ...r, barcode: e.target.value } // Use `barcode` to match updated logic
                                      : r
                                  );
                                  setAccessionRows(updatedRows);
                                }
                              }}
                              disabled={isChecked} // Disable manual entry if checkbox is checked
                            />
                          </td>
                          <td>
                            <Form.Select
                              value={row.location}
                              onChange={(e) => {
                                const updatedRows = accessionRows.map((r) =>
                                  r.id === row.id
                                    ? { ...r, location: e.target.value }
                                    : r
                                );
                                setAccessionRows(updatedRows);
                              }}
                              className="detail"
                            >
                              <option value="">Select Location</option>
                              {locations.map((loc) => (
                                <option key={loc.value} value={loc.value}>
                                  {loc.label}
                                </option>
                              ))}
                            </Form.Select>
                          </td>

                          {/* <td>
                            <Form.Select
                              value={row.status}
                              onChange={(e) => {
                                const updatedRows = accessionRows.map((r) =>
                                  r.id === row.id
                                    ? { ...r, status: e.target.value }
                                    : r
                                );
                                setAccessionRows(updatedRows);
                              }}
                              className="detail"
                            >
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="INACTIVE">INACTIVE</option>
                              <option value="LOST">LOST</option>
                              <option value="DAMAGED">DAMAGED</option>
                            </Form.Select>
                          </td> */}

                          <td>
                            <Form.Select
                              value={row.status}
                              onChange={(e) => {
                                const updatedRows = accessionRows.map((r) =>
                                  r.id === row.id
                                    ? { ...r, status: e.target.value }
                                    : r
                                );
                                setAccessionRows(updatedRows);
                              }}
                              className="detail"
                            >
                              <option value="">-- Select Status --</option>
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="INACTIVE">INACTIVE</option>
                              <option value="LOST">LOST</option>
                              <option value="DAMAGED">DAMAGED</option>
                            </Form.Select>
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              value={row.remarks}
                              style={{ width: "100%", padding: "5px" }}
                              size="sm"
                              onChange={(e) => {
                                const updatedRows = accessionRows.map((r) =>
                                  r.id === row.id
                                    ? { ...r, remarks: e.target.value }
                                    : r
                                );
                                setAccessionRows(updatedRows);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookForm;
